module.exports = __webpack_public_path__ + "media/src/images/icons/sync-outline-e563fb553059383c355df185ab084a96.svg";